<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>
  <!-- FILTROS -->
  <app-filters filtros
    [name]="'filtros.per' | translate"
    [array]="Periodos" 
    [typeFilter]="Filters.PERIOD"
    [click]="true"
    (eventClick)="cambioPeriodo($event)">
  </app-filters>
   <!-- CONTENIDO -->
  <div contenido class="zonaContenido">
    <div class="zonaIzquierda">
      <app-contenedor-elementos class="zonaSup" id="grafContPrin"
        [header]="{title: 'credito.mayores.tituloTabla'| translate, subtitles: [ {text: escrituraPeriodo(subTitles)}] }">
        @if (!tabMayPrin) {
          <mat-icon iconos class="iconoMen margenDer material-icons-outlined"
          [ngStyle]="{'color':'gray'}" (click)="etiquetas1 = !etiquetas1">
            {{!etiquetas1 ? 'label' : 'label_off'}}
          </mat-icon>
        }
        @if (!tabMayPrin) {              
          <mat-icon iconos class="iconoMen" [ngStyle]="{'color':'gray'}"
            (click)="ampliarGraf('prin')">
            zoom_out_map
          </mat-icon>
        }
        <mat-icon iconos [ngStyle]="{'color':'gray'}"
        [matMenuTriggerFor]="menuTabla">
          more_vert
        </mat-icon>
        <mat-menu #menuTabla="matMenu">
          <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="tipoGraficaPrin">
            <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
            {{'financiero.coberturaRiesgos.tooltipIcono1' | translate}}
          </button>
          @if (!tabMayPrin) {
          <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="graficaStack('', true)">
            <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">table_chart</mat-icon>
            <span>{{'financiero.catalogoCuentas.tooltipIcono1'|translate}}</span>
          </button>
          }
          <mat-divider/>
          @if (!tabMayPrin) {
          <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportarGrafica('grafContPrin', 'credito.mayores.tituloTabla', '')">
            <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
            <span>{{'menu.Exportar' | translate}}</span>
          </button>
          }
          @if (tabMayPrin) {
          <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportCartera()">
            <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
            <span>{{'menu.Exportar' | translate}}</span>
          </button>
          }
        </mat-menu>
        <mat-menu #tipoGraficaPrin="matMenu"> 
          <button class="mat-menu-item w3-caja-menu" [ngClass]="{'w3-disabled': tipoGraf2 === 'bar'}" [disabled]="tipoGraf2 === 'bar'" mat-menu-item (click)="graficaStack('bar', false)">
            <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
            <span>{{'credito.mayores.tipo3'|translate}}</span>
          </button>
          <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoGraf2 === 'area'}" [disabled]="tipoGraf2 === 'area'" (click)="graficaStack('area', false)">
            <mat-icon [ngStyle]="{'color':'gray'}">area_chart</mat-icon>
            <span>{{'credito.mayores.tipo4'|translate}}</span>
          </button>
          <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoGraf2 === 'line'}" [disabled]="tipoGraf2 === 'line'" (click)="graficaStack('line', false)">
            <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
            <span>{{'credito.mayores.tipo5'|translate}}</span>
          </button>
        </mat-menu>
        <div body class="tabla">
          <!-- contenido tabla -->
          @if (tabMayPrin) {
            @if(datos.length === 0){<app-skeleton-table [columnas]="9" [filas]="6"/>}
            @else {
              <table class="w3-table borderInf">
                <thead>
                  <tr class="w3-center">
                    <th class="stikyColumBlanco"></th>
                    <th class="stikyColumBlanco"></th>
                    <th class="w3-table-titleLow stikyColumCon w3-border-right-balance" colspan="5">{{'credito.mayores.tit1'| translate }}</th>
                    <th class="w3-table-titleLow stikyColumCon" colspan="2">{{'credito.mayores.tit2'| translate }}</th>
                  </tr>
                  <tr class="w3-table-title alinCenter " style="line-height: 1.2;">
                    <th class="stikyColumCon2 w3-border-right-balance" style="width: 150px;">{{'credito.mayores.enc1' | translate}}</th>
                    <th class="stikyColumCon2 w3-border-right-balance" style="width: 100px;">{{'credito.mayores.enc2' | translate}}</th>
                    <th class="stikyColumCon2 w3-border-right-balance">{{'credito.mayores.enc3' | translate}}</th>
                    <th class="stikyColumCon2 w3-border-right-balance">{{'credito.mayores.enc4' | translate}}</th>
                    <th class="stikyColumCon2 w3-border-right-balance" style="padding-right: 10px;">{{'credito.mayores.enc5' | translate}}</th>
                    <th class="stikyColumCon2 w3-border-right-balance">{{'credito.mayores.enc6' | translate}}</th>
                    <th class="stikyColumCon2 w3-border-right-balance w3-border-right-balance">{{'credito.mayores.enc7' | translate}}</th>
                    <th class="stikyColumCon2 w3-border-right-balance">
                      {{'credito.mayores.enc8' | translate}}
                    </th>
                    <th class="stikyColumCon2 w3-border-right-balance">{{'credito.mayores.enc9' | translate}}</th>
                  </tr>
                </thead>          
                <tbody>
                  @for (i of datos; track i.id; let pos = $index) {
                    <tr class="w3-table-trtd borderInfLow" style="width: 150px;">
                      <td class="borderAllLow">{{i.descripcion}}</td>
                      <td class="alinRight borderAllLow marginDer"  style="width: 100px;">
                        <span>{{i.saldo ?? 0 | formaterNumber:0:',':'.'}}</span>
                      </td>
                      <td class="alinRight borderAllLow marginDer">
                        <span>{{i.vigente ?? 0 | formaterNumber:0:',':'.'}}</span>
                      </td>
                      <td class="alinRight borderAllLow marginDer">
                        <span>{{i.vencido ?? 0 | formaterNumber:0:',':'.'}}</span>
                      </td>
                      <td class="alinRight borderAllLow marginDer">
                        <span>{{i.total ?? 0 | formaterNumber:0:',':'.'}}</span>
                      </td>
                      <td class="alinCenter borderAllLow">
                        <span>{{(i.porcen ?? 0*100) | formaterNumber:1:',':'.'}}%</span>
                      </td>
                      <td class="alinCenter borderAllLow">
                        <span>{{(i.mora ?? 0*100)| formaterNumber:1:',':'.'}}%</span>
                      </td>
                      <td class="alinCenter borderAllLow">
                        <div matTooltip="Editar" class="inputSpan" (dblclick)="actualizarLimite(i)">
                          <span>{{i.max}}%</span>
                          <mat-icon class="iconoMen" [ngStyle]="{'color':'gray'}">edit</mat-icon>
                        </div>
                      </td>
                      <td class="alinCenter">
                        @if (rango(i.porcen, i.max) == 'check_circle') {
                        <mat-icon class="iconoMen" matTooltip="{{'credito.mayores.ttCumpleLim' | translate}}" [ngStyle]="{'color':'#8bc34a'}">{{rango(i.porcen, i.max)}}</mat-icon>
                        }
                        @if (rango(i.porcen, i.max) == 'cancel') {
                        <mat-icon class="iconoMen" matTooltip="{{'credito.mayores.ttPasaLim' | translate}}" [ngStyle]="{'color':'red'}">{{rango(i.porcen, i.max)}}</mat-icon>
                        }
                      </td>              
                    </tr>
                  }           
                </tbody>          
              </table>
            } 
          }@else {
            <div class="grafica">
              <app-graficador
                #graficador2
                [data]="dataGrafica1"
                [labels]="labelsGrafica1"
                [type]="tipoGrafica1"
                [colors]="colorMulti"
                [axisY]="ejesYGrafica1"
                [axisX]="''"
                [zona]="1"
                [etiquetas]="etiquetas1"
                [formatEtiquetas]="false"
                [legend]="{enabled: true, position: 'bottom'}"
                [altoEtiquetasX]="80">
              </app-graficador>
            </div>
          }
        </div>
      </app-contenedor-elementos>      
      <div class="zonaInf">
        <app-contenedor-elementos class="tarjeta" id="grafContPV"
          [header]="{title: 'credito.mayores.titulotab1'| translate, subtitles: [ {text: escrituraPeriodo(subTitles)}]}">
          @if (!tabMayPV) {
            <div iconos>
              <mat-icon class="material-icons-outlined iconoMen margenDer" [ngStyle]="{'color':'gray'}" (click)="etiquetas3 = !etiquetas3">
                {{!etiquetas3 ? 'label' : 'label_off'}}
              </mat-icon>              
              <mat-icon class="iconoMen" [ngStyle]="{'color':'gray'}"
                (click)="ampliarGraf('pv')">
                zoom_out_map
              </mat-icon>  
            </div>            
          }
          <mat-icon iconos [ngStyle]="{'color':'gray'}"
          [matMenuTriggerFor]="menuTabla2">
            more_vert
          </mat-icon>
          <mat-menu #menuTabla2="matMenu">
            <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="tipoGraficaPV" >
              <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
              {{'financiero.coberturaRiesgos.tooltipIcono1' | translate}}
            </button>
            @if (!tabMayPV) {
            <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="graficaProp('', true)">
              <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">table_chart</mat-icon>
              <span>{{'financiero.catalogoCuentas.tooltipIcono1'|translate}}</span>
            </button>
            }
            <mat-divider/>
            @if (!tabMayPV) {
            <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportarGrafica('grafContPV', 'credito.mayores.titulotab1', '')">
              <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
              <span>{{'menu.Exportar' | translate}}</span>
            </button>
            }
            @if (tabMayPV) {
            <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportPV()">
              <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
              <span>{{'menu.Exportar' | translate}}</span>
            </button>
            }
          </mat-menu>
          <mat-menu #tipoGraficaPV="matMenu"> 
            <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoGraf3 === 'bar'}" [disabled]="tipoGraf3 === 'bar'" (click)="graficaProp('bar', false)">
              <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
              <span>{{'credito.mayores.tipo3'|translate}}</span>
            </button>
            <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoGraf3 === 'area'}" [disabled]="tipoGraf3 === 'area'" (click)="graficaProp('area', false)">
              <mat-icon [ngStyle]="{'color':'gray'}">area_chart</mat-icon>
              <span>{{'credito.mayores.tipo4'|translate}}</span>
            </button>
            <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoGraf3 === 'line'}" [disabled]="tipoGraf3 === 'line'" (click)="graficaProp('line', false)">
              <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
              <span>{{'credito.mayores.tipo5'|translate}}</span>
            </button>
          </mat-menu>
          <div body class="tabla">
            @if (tabMayPV) {          
              <table class="w3-table borderInf">
                <thead>
                  <tr class="w3-center">
                    <th class="stikyColumBlanco"></th>
                    <th class="w3-table-titleLow stikyColumCon w3-border-right-balance">{{'credito.mayores.enc10' | translate }}</th>
                    <th class="w3-table-titleLow stikyColumCon w3-border-right-balance">{{'credito.mayores.enc11' | translate }}</th>
                    <th class="w3-table-titleLow stikyColumCon w3-border-right-balance">{{'credito.mayores.enc12' | translate }}</th>
                  </tr>
                  <tr class="w3-center w3-table-title">
                    <th class="stikyColumCon2 w3-border-right-balance">{{'credito.mayores.enc1' | translate}}</th>
                    <th class="stikyColumCon2 w3-border-right-balance" style="font-weight: normal; font-size: 8pt;">{{encPropVar[0] ?? 0 | formaterNumber:0:miles:decimal}}</th>
                    <th class="stikyColumCon2 w3-border-right-balance" style="font-weight: normal; font-size: 8pt;">{{encPropVar[1] ?? 0 | formaterNumber:0:miles:decimal}}</th>
                    <th class="stikyColumCon2 w3-border-right-balance" style="font-weight: normal; font-size: 8pt;">{{encPropVar[2] ?? 0 | formaterNumber:0:miles:decimal}}</th>
                  </tr>
                </thead>
                @for (i of dataPropVar; track i.descripcion) {
                <tbody>
                  <tr class="w3-table-trtd borderInfLow" style="line-height: 1.2; font-size: 8pt;">
                    <td class="borderAllLow">
                      <span>{{i.descripcion}}</span>
                    </td>
                    <td class="alinCenter borderAllLow">
                      <span>{{(i.patrimonio ?? 0)*100 | formaterNumber:1:miles:decimal}}%</span>
                    </td>
                    <td class="alinCenter borderAllLow">
                      <span>{{(i.cartera ?? 0)*100 | formaterNumber:1:miles:decimal}}%</span>
                    </td>
                    <td class="alinCenter borderAllLow">
                      <span>{{(i.reservas ?? 0)*100 | formaterNumber:1:miles:decimal}}%</span>
                    </td>
                  </tr>
                </tbody>
                }
              </table>   
            }@else {
              <div class="graficaPV">
                @if (dataGrafica3.length === 0) {<app-skeleton-grafica />}
                @else {
                  <app-graficador
                    #graficador3
                    [data]="dataGrafica3"
                    [labels]="labelsGrafica3"
                    [type]="tipoGrafica3"
                    [colors]="colorMulti"
                    [axisY]="ejesYGrafica3"
                    [axisX]="''"
                    [zona]="3"
                    [etiquetas]="etiquetas3"
                    [formatEtiquetas]="false"
                    [legend]="{enabled: true, position: 'bottom'}"
                    [altoEtiquetasX]="80">
                  </app-graficador>
                }
              </div>
            }
          </div>
        </app-contenedor-elementos>
        <app-contenedor-elementos class="tarjeta"
          [header]="{title: 'credito.mayores.titulotab2'| translate, subtitles: [ {text:escrituraPeriodo(subTitles)}]}">
          <mat-icon iconos [ngStyle]="{'color':'gray'}"
          [matMenuTriggerFor]="menuTabla3">
            more_vert
          </mat-icon>
          <mat-menu #menuTabla3="matMenu">
            <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportLim();">
              <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
              <span>{{'menu.Exportar' | translate}}</span>
            </button>
          </mat-menu>
          <div body class="tabla">
            @if (dataLim.length != 0) {
              @if(idPlantilla === 7){
                <table class="w3-table borderInf">
                  <thead>
                    <tr class="w3-center">
                      <th class="w3-table-titleLow stikyColumCon w3-border-right-balance">{{'credito.mayores.enc1'| translate }}</th>
                      <th class="w3-table-titleLow stikyColumCon w3-border-right-balance">{{'credito.mayores.enc13'| translate }}</th>
                      <th class="w3-table-titleLow stikyColumCon w3-border-right-balance">{{'credito.mayores.enc14'| translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="w3-table-trtd borderInfLow" style="line-height: 1.2; font-size: 8pt;">
                      <td  class="borderAllLow">
                        {{'credito.mayores.descLim1' | translate}}
                      </td>
                      <td class="alinCenter borderAllLow" colspan="2">
                        <span>{{dataLim.saldo ?? 0 | formaterNumber:0:miles:decimal}}</span>
                      </td>
                    </tr>
                    <tr class="w3-table-trtd borderInfLow" style="line-height: 1.2; font-size: 8pt;">
                      <td class="borderAllLow">
                        {{'credito.mayores.descLim2' | translate}}
                      </td>
                      <td class="alinCenter borderAllLow">
                        <span>{{(dataLim.pCartera.norm ?? 0)*100 | formaterNumber:1:miles:decimal}}%</span>
                      </td>
                      <td class="alinCenter borderAllLow">
                        <div matTooltip="Editar" class="inputSpan" (dblclick)="actualizarCart()">
                          <span>{{obtLimit('porcentajeCartera') ?? 0 | formaterNumber:1:miles:decimal}}%
                            <mat-icon class="iconoMen" [ngStyle]="{'color':'gray'}">edit</mat-icon>
                          </span>
                        </div>
                      </td>
                    </tr>
                    <tr class="w3-table-trtd borderInfLow" style="line-height: 1.2; font-size: 8pt;">
                      <td class="borderAllLow" style="width: 120px;">
                        {{'credito.mayores.descLim3' | translate}}
                      </td>
                      <td class="alinCenter borderAllLow">
                        <span>{{dataLim.monto.norm ?? 0 | formaterNumber:0:miles:decimal}}</span>
                      </td>
                      <td class="alinCenter borderAllLow">
                        <span>{{dataLim.monto.int ?? 0 | formaterNumber:0:miles:decimal}}</span>
                      </td>
                    </tr>
                    <tr class="w3-table-trtd borderInfLow" style="line-height: 1.2; font-size: 8pt;">
                      <td class="borderAllLow">
                        {{'credito.mayores.descLim4' | translate}}
                      </td>
                      <td class="alinCenter borderAllLow">
                        <span>{{dataLim.nAcre.norm ?? 0 | formaterNumber:0:miles:decimal}}</span>
                      </td>
                      <td class="alinCenter borderAllLow">
                        <span>{{dataLim.nAcre.int ?? 0 | formaterNumber:0:miles:decimal}}</span>
                      </td>
                    </tr>
                    <tr class="w3-table-trtd borderInfLow" style="line-height: 1.2; font-size: 8pt;">
                      <td class="borderAllLow">
                        {{'credito.mayores.descLim5' | translate}}
                      </td>
                      <td class="alinCenter borderAllLow">
                        <span></span>
                      </td>
                      <td class="alinCenter borderAllLow">
                        <div matTooltip="Editar" class="inputSpan" (dblclick)="openModal()">
                          <span>{{obtLimit('montoMaximo') ?? 0 | formaterNumber:0:miles:decimal}}
                            <mat-icon class="iconoMen" [ngStyle]="{'color':'gray'}">edit</mat-icon>
                          </span>
                        </div>
                      </td>
                    </tr>
                    <tr class="w3-table-trtd borderInfLow" style="line-height: 1.2; font-size: 8pt;">
                      <td class="borderAllLow">
                        {{'credito.mayores.descLim6' | translate}}
                      </td>
                      <td class="alinCenter borderAllLow">
                        <span></span>
                      </td>
                      <td class="alinCenter borderAllLow" style="cursor: pointer;" matTooltip="{{'credito.mayores.mostrarCuentas'| translate}}" (dblclick)="mostrarCuentas()">
                        <span>{{dataLim.nSaldos ?? 0 | formaterNumber:0:miles:decimal}}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              }@else {
                <table class="w3-table borderInf">
                  <thead>
                    <tr class="w3-center">
                      <th class="w3-table-titleLow stikyColumCon w3-border-right-balance">{{'credito.mayores.enc1'| translate }}</th>
                      <th class="w3-table-titleLow stikyColumCon w3-border-right-balance">{{'credito.mayores.enc15'| translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="w3-table-trtd borderInfLow" style="line-height: 1.2; font-size: 8pt;">
                      <td class="borderAllLow">
                        {{'credito.mayores.descLim3' | translate}}
                      </td>
                      <td class="alinCenter borderAllLow">
                        <div matTooltip="Editar" class="inputSpan" (dblclick)="openModal()">
                          <span>{{dataLim.montoMax ?? 0 | formaterNumber:0:miles:decimal}}
                            <mat-icon class="iconoMen" [ngStyle]="{'color':'gray'}">edit</mat-icon>
                          </span>
                        </div>
                      </td>
                    </tr>                    
                    <tr class="w3-table-trtd borderInfLow" style="line-height: 1.2; font-size: 8pt;">
                      <td class="borderAllLow">
                        {{'credito.mayores.descLim4' | translate}}
                      </td>
                      <td class="alinCenter borderAllLow" style="cursor: pointer;" matTooltip="{{'credito.mayores.mostrarCuentas'| translate}}" (dblclick)="mostrarCuentas()">
                        <span>{{dataLim.nSaldos ?? 0 | formaterNumber:0:miles:decimal}}</span>
                      </td>
                    </tr>
                    <tr class="w3-table-trtd borderInfLow" style="line-height: 1.2; font-size: 8pt;">
                      <td class="borderAllLow">
                        {{'credito.mayores.descLim5' | translate}}
                      </td>
                      <td class="alinCenter borderAllLow">
                        <span>{{dataLim.cuentas[0].amortizacionCuotaSuma ?? 0 | formaterNumber:0:miles:decimal}}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              }
            }@else {<app-skeleton-table [columnas]="2" [filas]="4"/>}
            @if(idPlantilla !== 7){
              <div class="headers w3-titulo-contenidomenuSC"> <!-- barra titulo-->
                <div class="w3-noventa2"> <!--titulo tabla-->
                  <span class="">{{'credito.mayores.titulotab3'| translate }}</span>
                  <span class="w3-margin-left-contenido" style="color: gray; font-weight: 300;">&bull;</span>
                  <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPeriodo(subTitles)}}</span>
                </div>
              </div>
              <div class="tabla2">
                <table class="w3-table borderInf">
                    <thead>
                      <tr class="w3-center">
                        <th class="w3-table-titleLow stikyColumCon w3-border-right-balance">{{'credito.mayores.enc15'| translate }}</th>
                        <th class="w3-table-titleLow stikyColumCon w3-border-right-balance">{{'credito.mayores.enc16'| translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="w3-table-trtd borderInfLow" style="line-height: 1.2; font-size: 8pt;">
                        <td class="borderAllLow">{{gini.valor ?? 0 | formaterNumber:2:miles:decimal}}</td>
                        <td class="alinCenter borderAllLow">{{gini.concentracion}}</td>
                      </tr>
                    </tbody>
                  </table>
              </div>
            }
          </div>
        </app-contenedor-elementos>
      </div>
    </div>
    <app-contenedor-elementos class="zonaGraf" id="grafCont"
     [header]="{title: encNum + ' ' + ('credito.mayores.tituloGraf'| translate), subtitles: [ {text:escrituraPeriodo(subTitles)}]}">
      @if (!tabMay) {
        <div iconos>
          <mat-icon class="material-icons-outlined iconoMen margenDer" [ngStyle]="{'color':'gray'}" (click)="etiquetas2 = !etiquetas2">
            {{!etiquetas2 ? 'label' : 'label_off'}}
          </mat-icon>
          <mat-icon class="iconoMen" [ngStyle]="{'color':'gray'}"
          (click)="ampliarGraf('may')">
            zoom_out_map
          </mat-icon>  
        </div>        
      }
      <mat-icon iconos [ngStyle]="{'color':'gray'}" [matMenuTriggerFor]="menuGraf">
        more_vert
      </mat-icon>
      <mat-menu #menuGraf="matMenu">
        <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="Deudores">
          <mat-icon [ngStyle]="{'color':'gray'}">tag</mat-icon>
          <span>{{'credito.mayores.optNDeudores'| translate}}</span>
        </button>
        <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="tipoGrafica">
          <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
          {{'financiero.coberturaRiesgos.tooltipIcono1' | translate}}
        </button>
        @if (!tabMay) {
        <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="grafica('', hori, encNum, true, metrica)">
          <mat-icon class="material-icons-outlined" [ngStyle]="{'color':'gray'}">table_chart</mat-icon>
          <span>{{'financiero.catalogoCuentas.tooltipIcono1'|translate}}</span>
        </button>
        }
        @if (!tabMay) {
        <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportarGrafica('grafCont', 'credito.mayores.tituloGraf', encNum + ' ')">
          <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
          <span>{{'menu.Exportar' | translate}}</span>
        </button>
        }
        @if (tabMay) {
        <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportMayoresDeu()">
          <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
          <span>{{'menu.Exportar' | translate}}</span>
        </button>
        }
      </mat-menu>
      <mat-menu #Deudores="matMenu">
        <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': encNum === 10}" [disabled]="encNum === 10" (click)="grafica(tipoGraf, hori, 10, tabMay, metrica)">
          <span>10</span>
        </button>
        <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': encNum === 25}" [disabled]="encNum === 25" (click)="grafica(tipoGraf, hori, 25, tabMay, metrica)">
          <span>25</span>
        </button>
        <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': encNum === 50}" [disabled]="encNum === 50" (click)="grafica(tipoGraf, hori, 50, tabMay, metrica)">
          <span>50</span>
        </button>
        @if (tabMay) {
        <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': encNum === 100}" [disabled]="encNum === 100" (click)="grafica(tipoGraf, hori, 100, tabMay, metrica)">
          <span>100</span>
        </button>
        }
      </mat-menu>
      <mat-menu #tipoGrafica="matMenu"> 
        <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoGraf === 'bar' && hori}" [disabled]="tipoGraf === 'bar' && hori" (click)="grafica('bar', true, encNum, false, metrica)">
          <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
          <span>{{'credito.mayores.tipo1'|translate}}</span>
        </button>
        <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoGraf === 'bar' && !hori}" [disabled]="tipoGraf === 'bar' && !hori" (click)="grafica('bar', false, encNum, false, metrica)">
          <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
          <span>{{'credito.mayores.tipo2'|translate}}</span>
        </button>
        <button class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoGraf === 'area'}" [disabled]="tipoGraf === 'area'" (click)="grafica('area', false, encNum, false, metrica)">
          <mat-icon [ngStyle]="{'color':'gray'}">area_chart</mat-icon>
          <span>{{'credito.mayores.tipo4'|translate}}</span>
        </button>
      </mat-menu>
      <mat-menu #menuMetrica="matMenu">
        <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="grafica(tipoGraf, hori, encNum, tabMay, true)">
          <span>{{'credito.mayores.metrica1'|translate}}</span>
        </button>
        @if (vencido) {
        <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="grafica(tipoGraf, hori, encNum, tabMay, false)">
          <span>{{'credito.mayores.metrica2'|translate}}</span>
        </button>
        }
      </mat-menu>
      <div body class="tabla">
        @if (!tabMay) {
          <div class="graficaM">
            @if(dataGrafica2.length == 0) {<app-skeleton-grafica />}
            @else{
              <app-graficador
                #graficador1
                [data]="dataGrafica2"
                [labels]="labelsGrafica2"
                [type]="tipoGrafica2"
                [colors]="colorMulti"
                [axisY]="ejesYGrafica2"
                [axisX]="ejesXGrafica2"
                [zona]="2"
                [etiquetas]="etiquetas2"
                [formatEtiquetas]="true"
                [legend]="{enabled: true, position: 'bottom'}">
              </app-graficador>
            }        
          </div>        
        }@else {
          <table class="w3-table borderInf">
            <thead>
              <tr>
                <th class="w3-table-titleLow stikyColumCon w3-border-right-balance marginsH">{{'credito.mayores.tit3'| translate }}</th>
                <th class="w3-table-titleLow stikyColumCon w3-border-right-balance marginsH">{{'credito.mayores.tit4'| translate }}</th>
                @if(idPlantilla === 7){
                  <th class="w3-table-titleLow stikyColumCon w3-border-right-balance marginsH">{{'credito.mayores.tit5'| translate }}</th>
                  <th class="w3-table-titleLow stikyColumCon w3-border-right-balance marginsH">{{'credito.mayores.tit6'+idPlantilla| translate }}</th>
                }
                @if(idPlantilla === 12){
                  <th class="w3-table-titleLow stikyColumCon w3-border-right-balance marginsH">{{'credito.mayores.tit7'| translate }}</th>
                  <th class="w3-table-titleLow stikyColumCon w3-border-right-balance marginsH">{{'credito.mayores.enc3'| translate }}</th>
                  <th class="w3-table-titleLow stikyColumCon w3-border-right-balance marginsH">{{'credito.mayores.enc4'| translate }}</th>
                  <th class="w3-table-titleLow stikyColumCon w3-border-right-balance marginsH">{{'credito.mayores.tit6'+idPlantilla| translate }}</th>
                }              
              </tr>
            </thead>
            @for (i of datosGrafTab; track i.numeroCredito; let j = $index) {
            <tbody>
              <tr class="w3-table-trtd borderInfLow">
                <td class="alinCenter borderAllLow">
                  <span>{{j+1}}</span>
                </td>
                @if(idPlantilla === 7){
                  <td class="alinCenter borderAllLow">
                    <span>{{i.numeroSocio}}</span>
                  </td>
                  <td class="alinCenter borderAllLow">
                    <span>{{i.numeroCredito ?? 0 | formaterNumber:0:miles:decimal}}</span>
                  </td>
                }@else {
                  <td class="alinCenter borderAllLow">
                    <span>{{i.numeroSocio}}</span>
                  </td>
                  <td class="alinCenter borderAllLow">
                    <span>{{i.creditos ?? 0 | formaterNumber:0:miles:decimal}}</span>
                  </td>
                  <td class="alinCenter borderAllLow">
                    <span>{{i.saldoVigente ?? 0 | formaterNumber:0:miles:decimal}}</span>
                  </td>
                  <td class="alinCenter borderAllLow">
                    <span>{{i.saldoVencido ?? 0 | formaterNumber:0:miles:decimal}}</span>
                  </td>                
                }
                <td class="alinCenter borderAllLow">
                  <span>{{i.amortizacionCuotaSuma ?? 0 | formaterNumber:0:miles:decimal}}</span>
                </td>
              </tr>
            </tbody>
            }
          </table>
        }
      </div>
    </app-contenedor-elementos>
  </div>
</app-esqueleto-tableros>

<!--Modal ampliar grafica-->
 <app-modal [isOpen]="modalOpen" (close)="modalOpen = !modalOpen" [export]="true" [iconoExport]="'image'"
  [labels]="true" [labelsState]="showLabels()" (changeLables)="changeLabels()" (exportFile)="exportarModal()">
  <div modal-header>
    <span class="w3-margin-left-contenido">
      @if (tituloModal == 'prin') {{{'credito.mayores.tituloTabla'| translate}}}
      @if (tituloModal == 'may') {{{encNum}} {{'credito.mayores.tituloGraf'| translate}}}
      @if (tituloModal == 'pv') {{{'liquidez.mayores.titulotab1'| translate}}}
    </span>
    <span class="w3-punto-subtitulo w3-margin-left-filter">&bull;</span>
    <span class=" w3-margin-left-filter w3-subtitulo">{{ escrituraPeriodo(subTitles) }}</span>
  </div>
  <div modal-body style="height: 60vh; width: 70vw;">
    <div class="w3-row" style="height: 58vh;">
      @if (tituloModal == 'prin') {
        <app-graficador
          [data]="dataGrafica1"
          [labels]="labelsGrafica1"
          [type]="tipoGrafica1"
          [colors]="colorMulti"
          [axisY]="ejesYGrafica1"
          [axisX]="''"
          [zona]="4"
          [etiquetas]="etiquetas1"
          [formatEtiquetas]="false"
          [legend]="{enabled: true, position: 'bottom'}">
        </app-graficador>
      }
      @if (tituloModal == 'may') {
        <app-graficador
          [data]="dataGrafica2"
          [labels]="labelsGrafica2"
          [type]="tipoGrafica2"
          [colors]="colorMulti"
          [axisY]="ejesYGrafica2"
          [axisX]="ejesXGrafica2"
          [zona]="5"
          [etiquetas]="etiquetas2"
          [formatEtiquetas]="false"
          [legend]="{enabled: true, position: 'bottom'}">
        </app-graficador>
      }
      @if (tituloModal == 'pv') {
        <app-graficador
          [data]="dataGrafica3"
          [labels]="labelsGrafica3"
          [type]="tipoGrafica3"
          [colors]="colorMulti"
          [axisY]="ejesYGrafica3"
          [axisX]="''"
          [zona]="6"
          [etiquetas]="etiquetas3"
          [formatEtiquetas]="false"
          [legend]="{enabled: true, position: 'bottom'}">
        </app-graficador>
      }
    </div>
  </div>
</app-modal>

<div id="porcentajes" class="modal" (click)="clickFuera($event, true)">
  <div id="porcentajesContenido" class="modalContent" style="width: 30%; border-radius: 10px;">
    <div class="w3-titulo-contenidomenu modalHeader w3-center" style="line-height: 1.2;">
      <span class="w3-margin-left-contenido">{{'credito.mayores.ingValor'+idPlantilla| translate}}</span>
    </div>
    <div style="padding-left: 2%; padding-bottom: 1%; padding-right: 2%; margin-top: 2vh;">
      <div  class="w3-center">
        <div class="w3-row" [formGroup]="formEvento">
          <input currencyMask class="contentInputNumber"
          [options]="{prefix: ''+prefix, thousands: ''+miles, decimal: ''+decimal, precision: precicion,suffix: ' '+suffix, align: aling}"
          formControlName="monto">
        </div>
      </div>
      <div class="zonaButtons">
          <a class="swipe-overlay-out letrasCorreo" >
            <div class="botonesModales">
              <button mat-flat-button color="success" style="height: 4vh;" (click)="actMontoMax()">
                {{'swal.guardar'| translate}}
              </button>  
            </div>
          </a>
          <a class="swipe-overlay-out letrasCorreo" >
            <div class="botonesModales">
              <button mat-stroked-button color="success2" (click)="closeModal2(true)"  style="height: 4vh;">{{'swal.cerr'| translate}}</button>
            </div>
          </a>
      </div>
    </div>
  </div>
</div>
<div id="cuentas" class="modal" (click)="clickFuera($event)">
  <div id="" class="modalContent" style="width: 70%;">
    <div class="w3-row w3-white">
      <!--Titulo grafica modal-->
      <div class="w3-row w3-noventa2 w3-white">
        <div class="w3-row  w3-header-cuadrante padreizquierda" style="height: 6vh; margin-top: 10px; margin-left: 20px">
          <div class="w3-noventa2 w3-titulo-contenidomenu bottom hijoizquierdaTitle" >
            <span class="w3-margin-left-contenido">{{
              'credito.mayores.titTab' | translate}}
            </span>
            <span class="w3-margin-left-contenido">&bull;</span>
            <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPeriodo(subTitles)}}</span>
          </div>
        </div>
      </div>
      <!--cerrar modal-->
      <div class="w3-rest w3-right w3-white" style="height: 6vh; margin-top: 10px;">
        <div class="w3-row" style="height: 3vh; transform: translate(0, 40%);">
          <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}" (click)="exportarCuentas()">description</mat-icon>
          <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}" (click)="closeModalCuentas()">clear</mat-icon>
        </div>
      </div>
    </div>
    
    <div class="w3-scroll" style="padding-left: 2%; padding-bottom: 3%; padding-right: 2%; margin-top: 2vh; max-height: 70vh;">
      <table class="w3-table">
        <thead>
          <tr class="w3-center">
            <th class="w3-table-titleLow stikyColumCon w3-border-right-balance">{{'credito.mayores.tit3' | translate}}</th>
            <th class="w3-table-titleLow stikyColumCon w3-border-right-balance">{{'credito.mayores.tablaCuentasTitulo1' | translate}}</th>
            <th class="w3-table-titleLow stikyColumCon w3-border-right-balance">{{'credito.mayores.tablaCuentasTitulo2' | translate}}</th>
            <th class="w3-table-titleLow stikyColumCon w3-border-right-balance">{{'credito.mayores.tablaCuentasTitulo3' | translate}}</th>
          </tr>
        </thead>
        @for (d of dataLim.cuentas; track d.numeroCredito; let i = $index) {
        <tbody>
          <tr class="w3-table-trtd w3-center borderInf">
            <td class="borderAllLow">{{i+1}}</td>
            <td class="borderAllLow">{{d.numeroSocio}}</td>
            <td class="borderAllLow">{{d.numeroCredito| formaterNumber:0:miles:decimal}}</td>
            <td class="borderAllLow alinRight marginDer">{{d.amortizacionCuotaSuma | formaterNumber:0:miles:decimal}}  </td>
          </tr>
        </tbody>
        }
      </table>
    </div>
  </div>
</div>
